// extracted by mini-css-extract-plugin
module.exports = {"container":"_3YpRv2","alignCenter":"_1vCjRG","paddingTop":"CXh5EN","paddingBottom":"_2FmPoW"};